import { HideNavParam } from 'Modulor/components/Header/constants';
import { parseBooleanParam } from 'utils/common';

import { LIGHT_THEME_MODE_TYPE } from '../../services/theme';
import type { ParamsSnapshot } from '../slices/global';

const stringOrEmpty = (v: unknown): string => (typeof v === 'string' ? v : '');

export const stringToNumber = (v: unknown): number => {
  if (typeof v === 'string') {
    const numbered = Number(v);
    return Number.isNaN(numbered) ? 0 : numbered;
  }

  return 0;
};

export const getLangBrand = (param: string): [string, string] => {
  let lang = 'en';
  let brand = '';

  try {
    const [paramLang, paramBrand] = param.split('-');
    if (typeof param === 'string') {
      if (paramLang) {
        lang = paramLang;
      }
      if (paramBrand) {
        brand = paramBrand;
      }
    }
  } catch {
    /* empty */
  }

  return [lang, brand];
};

export const formatInitialQueryParams = (query: string): ParamsSnapshot => {
  const params = new URLSearchParams(query);
  const get = (key: string) => params.get(key);

  const sessionId = get('session_id') || get('cashier_session_id') || '';
  const [lang, brand] = getLangBrand(get('lang') as string);
  const width = get('width');
  const height = get('height');

  return {
    sessionId,
    lang,
    brand,
    preselectedPayGroupId: stringOrEmpty(get('pay_group')),
    userId: stringOrEmpty(get('user')),
    clickstreamId: stringOrEmpty(get('clstrmid')),
    metrics: stringToNumber(get('metrics')),
    parentWidth: width ? Number(width) : window.innerWidth,
    parentHeight: height ? Number(height) : window.innerHeight,
    merchantRedirectUrl: stringOrEmpty(get('merchant_redirect_url')),
    inPopUp: parseBooleanParam(get('in_pop_up')),
    isAlwaysClose: parseBooleanParam(get('close_icon')),
    mode: get('mode') || LIGHT_THEME_MODE_TYPE,
    hidenav: get('hidenav') === HideNavParam.True,
  };
};

export const applyDateMask = (value: string, format: string, prevValue?: string): string => {
  const delimiter = format.replace(/\w/g, '').toString()[0];
  const yearFirstFlow = /^\w{4}/g.test(format);

  // Detect backspace: new value is shorter than previous
  const isBackspace = prevValue !== undefined && value.length < prevValue.length;

  // Get only digits from input
  let newValue = value.replace(/\D/g, '').toString();

  // If backspace and the deleted character was a delimiter, remove one more digit
  if (isBackspace && prevValue) {
    const deletedChar = prevValue.slice(value.length, value.length + 1);
    if (deletedChar === delimiter && newValue.length > 0) {
      newValue = newValue.slice(0, -1);
    }
  }

  if (yearFirstFlow) {
    if (newValue.length > 4 && newValue.length < 6) {
      newValue = `${newValue.slice(0, 4)}${delimiter}${newValue.slice(4, 6)}`;
    } else if (newValue.length >= 6) {
      newValue = `${newValue.slice(0, 4)}${delimiter}${newValue.slice(4, 6)}${delimiter}${newValue.slice(6, 8)}`;
    }
  } else if (newValue.length >= 3 && newValue.length <= 4) {
    newValue = `${newValue.slice(0, 2)}${delimiter}${newValue.slice(2)}`;
  } else if (newValue.length >= 5) {
    newValue = `${newValue.slice(0, 2)}${delimiter}${newValue.slice(2, 4)}${delimiter}${newValue.slice(4, 8)}`;
  }
  return newValue;
};
